import { render, staticRenderFns } from "./FbText.vue?vue&type=template&id=7d24528b"
import script from "./FbText.vue?vue&type=script&lang=js"
export * from "./FbText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports